import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { ExerciseHistory } from '@/lib/types';

interface Props {
  history: ExerciseHistory;
  onPress: () => void;
}

function formatDate(iso: string): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
}

export function ExerciseProgressCard({ history, onPress }: Props) {
  const { name, muscleGroup, lastLoad, delta, lastPerformedAt } = history;

  const deltaText = delta === null ? '—' : delta > 0 ? `↑ +${delta.toFixed(1)}kg` : delta < 0 ? `↓ ${delta.toFixed(1)}kg` : '= sem variação';
  const deltaColor = delta === null ? '#888' : delta > 0 ? '#2E7D32' : delta < 0 ? '#C8102E' : '#888';

  return (
    <TouchableOpacity style={styles.card} onPress={onPress} activeOpacity={0.75}>
      <View style={styles.left}>
        <Text style={styles.name}>{name}</Text>
        <Text style={styles.muscle}>{muscleGroup}</Text>
        <Text style={styles.date}>Último: {formatDate(lastPerformedAt)}</Text>
      </View>
      <View style={styles.right}>
        <Text style={styles.load}>{lastLoad !== null ? `${lastLoad}kg` : '— kg'}</Text>
        <Text style={[styles.delta, { color: deltaColor }]}>{deltaText}</Text>
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  card: { flexDirection: 'row', backgroundColor: '#fff', borderRadius: 10, padding: 14, marginBottom: 8, alignItems: 'center' },
  left: { flex: 1 },
  name: { fontSize: 14, fontWeight: '600', color: '#1A1A1A' },
  muscle: { fontSize: 11, color: '#888', marginTop: 2 },
  date: { fontSize: 11, color: '#aaa', marginTop: 4 },
  right: { alignItems: 'flex-end' },
  load: { fontSize: 18, fontWeight: 'bold', color: '#1A1A1A' },
  delta: { fontSize: 12, fontWeight: '600', marginTop: 4 },
});
